import { render, staticRenderFns } from "./DeclarationsFilters.vue?vue&type=template&id=da08f156&scoped=true&"
import script from "./DeclarationsFilters.vue?vue&type=script&lang=ts&"
export * from "./DeclarationsFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da08f156",
  null
  
)

export default component.exports